<template>
  <div>
    <Navigator :title="serviceChildName"></Navigator>
    <RecommendedDemo :msg="recommendedInfo" :isInfo="true"></RecommendedDemo>
    <div class="box">
      <div class="couponImg">
        <img :src="recommendedInfo.couponImg" alt="">
      </div>
      <div class="textContent">
        <h3 class="title">服务介绍</h3>
        <div class="text" v-html="recommendedInfo.content" ref="text" :class="{ 'textHeight': textShow }"></div>
        <div class="textShow" @click="textShow = false" v-show="textShow">
          展开
          <i class="iconfont icon-zhankai mainColor"></i>
        </div>
      </div>
      <div class="who">
        <h3 class="title">谁在用</h3>
        <div class="icon">
          <img :src="item" alt="" v-for="(item, index) in recommendedInfo.whoUsingList" :key="index">
        </div>
      </div>
      <div class="customer">
        <h3 class="title">客户说</h3>
        <div class="customerTitle clearfix">
          <img :src="recommendedInfo.customerLogo" alt="">
          <h4>{{ recommendedInfo.customerUser }}</h4>
          <p class="company">{{ recommendedInfo.customerName }}</p>
        </div>
        <p class="introduce" v-html="recommendedInfo.customerDesc"></p>
      </div>
      <div class="merchants">
        <h3 class="title">服务提供商</h3>
        <div class="content clearfix">
          <img :src="recommendedInfo.sponsorLogo" alt="">
          <div class="introduce">
            <h4>{{ recommendedInfo.providerName }}</h4>
            <p class="color_102">{{ recommendedInfo.sponsorLable }}</p>
            <p class="color_102">{{ recommendedInfo.sponsorDesc }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="recommendedInfo.serviceQrcodeList">
      <QrcodeQuickEntry :serviceQrcodeList="recommendedInfo.serviceQrcodeList"></QrcodeQuickEntry>
    </div>

    <div class='footer'>
      <mt-button @click='apply' size="small">报 名</mt-button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast, Indicator } from 'mint-ui';
import RecommendedDemo from '../components/RecommendedDemo';
import QrcodeQuickEntry from '@/components/QrcodeQuickEntry';

export default {
  data() {
    return {
      recommendedInfo: {},
      textShow: true,
      serviceMsg: {},
      serviceChildName: '优选服务',
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList', 'qrcodeServiceInfo']),
  },
  created() {
    if (this.parkServiceList.length) {
      this.serviceMsg = this.parkServiceList.find((val) => {
        return val.serviceFlag === 2;
      });
      this.getServiceChildName();
    }
    this.getInfo();
  },
  methods: {
    getServiceChildName() {
      const arrIndex = this.serviceMsg.children.findIndex((val) => {
        return val.type === 11;
      });
      if (arrIndex !== -1) {
        this.serviceChildName = this.serviceMsg.children[arrIndex].serviceName;
      } else {
        this.serviceChildName = '优选服务';
      }
    },
    getInfo() {  // 获取优选服务详情
      Indicator.open('加载中...');
      setTimeout(() => {
        Indicator.close();
      }, 5000);
      this.$http.post(`${this.URL_PREFIX}/app/get/fine/service/info/detail`, {
        parkId: this.currentParkId,
        serviceId: this.$route.params.fineServiceId,
        qrId: this.$route.query.qrId || '',
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        Indicator.close();
        if (res.resCode === '10000') {
          res.resData.whoUsingList =  res.resData.whoUsingList ? res.resData.whoUsing.split(',') : '';
          this.recommendedInfo = res.resData;
        }
      });
    },
    apply() {  // 申请
      if (this.token) {
        this.submit();
      } else {
        // 授权登录
        this.$root.eventHub.$emit('login', root.$route.path);
      }
    },
    submit() {  // 提交表单
      Indicator.open('正在提交...');
      setTimeout(() => {
        Indicator.close();
      }, 5000);
      this.$http.post(`${this.URL_PREFIX}/app/added/fine/service/order`, {
        parkId: this.currentParkId,
        serviceId: this.$route.params.fineServiceId,
        qrId: this.$route.query.bindQr==1 ? (this.qrcodeServiceInfo.qrId || undefined) : undefined,
      },{
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        Indicator.close();
        if (res.resCode === '10000') {
          Toast({
            message: '订单提交成功！',
            iconClass: 'icon icon-success',
          });
        } else if (res.resCode === '12004'){
          Toast('该功能仅限已入驻园区的企业用户使用，请联系您的企业管理员。未入住园区的企业，请使用PC端在线提交入驻申请。');
        } else {
          Toast(res.resDesc);
        }
      });
    },
  },
  components: {
    RecommendedDemo,
  },
  updated() {
    const textImg = this.$refs.text.querySelectorAll('img');
    const textHeight = this.$refs.text.offsetHeight;
    if (textHeight < 300) {
      this.textShow = false;
    }
    textImg.forEach((val) => {
      val.style.maxWidth = '100%';
    });
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss';

.box{
  & > div{
    border-bottom: px2rem(10) solid #f5f5f5;
    &:first-child{
      border-top: px2rem(10) solid #f5f5f5;
    }
    &:last-child{
      border-bottom: none;
    }
  }
}

.couponImg {
  height: px2rem(186);
  background-color: #fff;
  padding: px2rem(24);
  img {
    width: 100%;
    height: 100%;
  }
}

.title {
  padding: px2rem(27) px2rem(24);
  font-size: px2rem(34);
  font-weight: bold;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(245, 245, 245);
}
.textContent {
  background-color: #fff;
  .text {
    margin: .32rem;
    overflow-y: auto;
    line-height: px2rem(42);
  }
  .textHeight {
    max-height: 8rem;
    overflow: hidden;
  }
  .textShow {
    text-align: center;
    .icon-zhankai {
      font-size: .186667rem;
    }
  }
}

.who {
  background-color: #fff;
  .icon {
    padding-top: .266667rem;
    padding-bottom: .266667rem;
    img {
      width: 1.173333rem;
      height: 1.173333rem;
      border-radius: 50%;
      margin-left: px2rem(30);
      &:first-child{
        margin-left: px2rem(24);
      }
    }
  }
}

.customer {
  background-color: #fff;
  .customerTitle {
    padding: px2rem(24) px2rem(24) 0;
    img {
      width: 1.066667rem;
      height: 1.066667rem;
      border-radius: 50%;
      margin-right: px2rem(20);
      float: left;
    }
    h4 {
      font-size: px2rem(34);
      margin-top: px2rem(6);
      color: #333;
      line-height: 1;
    }
    p {
      font-size: px2rem(24);
      color: #666;
      margin-top: px2rem(14);
      line-height: 1;
    }
  }
  .introduce {
    padding: px2rem(20) px2rem(24) px2rem(24);
    font-size: px2rem(30);
    line-height: px2rem(42);
  }
}

.merchants {
  background-color: #fff;
  .content {
    margin: px2rem(24);
    padding: px2rem(20);
    background-color: #f5f5f5;
  }
   img {
    width: px2rem(120);
    height: px2rem(120);
    float: left;
    margin-right: px2rem(14);
  }
  .introduce {
    float: left;
    line-height: 1;
    h4 {
      font-size: px2rem(34);
      color: #333;
      margin-top: px2rem(6);
    }
    p {
      font-size: px2rem(24);
      color: #666;
      margin-top: px2rem(14);
    }
  }
}
.box {
  padding-bottom: 60px;
}
.footer{
  padding: px2rem(16) px2rem(24);
  background-color: #f5f5f5;
  margin-top: .4rem;
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  bottom: 0;
  .mint-button{
    width: 100%;
    background: $color-main;
    color: #fff;
    font-size: .4rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/business/child/RecommendInfo.vue